import Image from 'next/image';
import { twMerge } from 'tailwind-merge';

interface TeamImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
}

export const TeamImage = (props: TeamImageProps) => {
  const { src, alt, width, height, className } = props;
  const combinedClassName = twMerge(
    'flex h-[40px] w-[40px] justify-center rounded-full bg-[#272727] p-2 md:h-[86px] md:w-[86px] lg:p-5',
    className
  );
  return (
    <div className={combinedClassName}>
      <Image src={src} alt={alt} width={width} height={height} />
    </div>
  );
};
